import { render, staticRenderFns } from "./HoldingsDetailsView.vue?vue&type=template&id=fc2ca84c&scoped=true&"
import script from "./HoldingsDetailsView.vue?vue&type=script&lang=js&"
export * from "./HoldingsDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./HoldingsDetailsView.vue?vue&type=style&index=0&id=fc2ca84c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2ca84c",
  null
  
)

export default component.exports